import { RunGroupStatus } from "@custom-types/modelRun"
import { ChangeCircle, CheckCircle, ErrorRounded } from "@mui/icons-material"
import { DefaultComponentProps, OverridableTypeMap } from "@mui/material/OverridableComponent"

export type RunGroupStatusIconProps = DefaultComponentProps<OverridableTypeMap> & {
  status: RunGroupStatus
}

const RunGroupStatusIcon = ({ status, ...props }: RunGroupStatusIconProps) => {
  switch (status) {
    case RunGroupStatus.DONE:
      return <CheckCircle sx={{ color: "#2a862a", fontSize: 20, ...props?.sx }} />
    case RunGroupStatus.RUNNING:
      return <ChangeCircle sx={{ color: "#e19d21", fontSize: 20, ...props?.sx }} />
    case RunGroupStatus.ERROR:
      return <ErrorRounded sx={{ color: "#ef0000", fontSize: 20, ...props?.sx }} />
    default:
      return <></>
  }
}

export default RunGroupStatusIcon
